"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectivityReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
var _ReadinessCheck2 = require("../ReadinessCheck.styled");
var _passedReadiness = _interopRequireDefault(require("../passed-readiness.svg"));
var _failedReadiness = _interopRequireDefault(require("../failed-readiness.svg"));
var getIcon = function getIcon(status) {
  if (status) {
    return _react["default"].createElement(_ReadinessCheck2.StyledIcon, {
      src: _failedReadiness["default"]
    });
  }
  return _react["default"].createElement(_ReadinessCheck2.StyledIcon, {
    src: _passedReadiness["default"]
  });
};
var ConnectivityReadiness = exports.ConnectivityReadiness = function ConnectivityReadiness(_ref) {
  var status = _ref.status,
    onRetry = _ref.onRetry,
    hideBottomBorder = _ref.hideBottomBorder,
    udp = _ref.udp,
    tcp = _ref.tcp,
    presenterId = _ref.presenterId;
  var statusText = status === _constants.FAILED ? 'Trouble connecting to Studio' : null;
  return _react["default"].createElement(_ReadinessCheck["default"], {
    title: "Connectivity",
    status: status,
    onRetry: onRetry,
    hideBottomBorder: hideBottomBorder,
    statusText: statusText,
    failedText: statusText,
    presenterId: presenterId
  }, _react["default"].createElement(_ReadinessCheck2.StyleP, null, "Please turn off any ad blockers / browser extensions that may be restricting network traffic."), _react["default"].createElement(_ReadinessCheck2.StyleP, null, "If you are on a corporate network, vpn or have a firewall, please confirm the following destinations / ports are white listed:"), _react["default"].createElement(_ReadinessCheck2.StyledDiv, null, _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true
  }, getIcon(tcp), "chime.aws"), _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true,
    $textRight: true
  }, "TCP/443")), _react["default"].createElement(_ReadinessCheck2.StyledDiv, null, _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true
  }, getIcon(tcp), "*.chime.aws"), _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true,
    $textRight: true
  }, "TCP/443")), _react["default"].createElement(_ReadinessCheck2.StyledDiv, null, _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true
  }, getIcon(tcp), "*.amazonaws.com"), _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true,
    $textRight: true
  }, "TCP/443")), _react["default"].createElement(_ReadinessCheck2.StyledDiv, null, _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true
  }, getIcon(tcp), "99.77.128.0/18"), _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: tcp,
    $noMargin: true,
    $textRight: true
  }, "TCP/443")), _react["default"].createElement(_ReadinessCheck2.StyledDiv, null, _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: udp
  }, getIcon(udp), "99.77.128.0/18"), _react["default"].createElement(_ReadinessCheck2.StyleP, {
    $textRed: udp,
    $textRight: true
  }, "UDP/3478")), _react["default"].createElement(_ReadinessCheck2.StyleP, null, "Please reach out to your IT team for help."));
};
ConnectivityReadiness.defaultProps = {
  status: _constants.CHECKING,
  udp: false,
  tcp: false
};
ConnectivityReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  onRetry: _propTypes.func,
  udp: _propTypes.bool,
  tcp: _propTypes.bool,
  presenterId: _propTypes.string,
  hideBottomBorder: _propTypes.bool
};